/* eslint-disable no-process-env */
// From current knowledge privacy policy URL and tealium URL are same for all markets and all brands.

let UTAG_URL;
let UTAG_EMULATION_URL;
if (process.env.NODE_ENV === 'production') {
  UTAG_URL = process.env.UTAG_URL;
  UTAG_EMULATION_URL = process.env.UTAG_EMULATION_URL;
} else {
  UTAG_URL = 'https://tags.tiqcdn.com/utag/godaddy/dev-server/dev/utag.js';
  UTAG_EMULATION_URL = 'https://img6.dev-wsimg.com/utag/utag.min.js';
}

//
// TODO (crobbins): remove this once @godaddy/markets
// has been updated to be more tree shake friendly
//
export const RTL_MARKETS = ['ar'];

//
// The following values are specific to GoDaddy. In order to get values for
// all {Account, Profile} pairs run:
//
// const cts = utui.data.customizations;
// Object.keys(cts).forEach(cid => {
//   if (cts[cid].catNameIdLookup) {
//     copy(cts[cid].catNameIdLookup.replace(/\&quot\;/g, '"'));
//   }
// });
//
// from the "Extensions" page inside of TealiumIQ
//
export const OPT_OUT_CATS = {
  advertising: 2,
  analytics: 9,
  support: 11
};

// Don't know about Dev URL, assign production URL
export const PRIVACY_POLICY_URL = process.env.PRIVACY_POLICY_URL;
export {
  UTAG_URL,
  UTAG_EMULATION_URL
};

// This is the last "reset date" after which a new interaction
// is required in order to get fresh consent
//
// NOTE: When updating, be sure to set time to *AFTER* deploy
// with large enough window that relevant HTTP caches get
// invalidated

// GDPR Launch Date
// 2018-05-23 18:00:00 GMT
// 1527098400000
export const GDPR_DATE = 1527098400000;

// 2021-05-17 22:00:00 GMT
// 1621288800000
export const CONSENT_DATE = 1621288800000;
